import styled from 'styled-components';

export default styled.section`
  background-color: ${(props) => props.theme.secondaryColor};
  padding: 30px 0;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    background-image: url(${(props) => props.image});
    background-repeat: no-repeat;
    background-position: 90% center;
  }
`;
